import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { form } from 'helpers/decorators'
import validate from './add-logs.validation'
import { Input, InputDate, Textarea, TimePicker } from '../../../../components/fields'
import { ImagePicker } from '../../../misc'

@form({
  form: 'addLogs',
  disableHook: true,
  validate
})
class AddLogs extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    onAddLogs: PropTypes.func,
    reset: PropTypes.func,
    activityId: PropTypes.string,
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    submitDisabled: PropTypes.bool,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    storeRemoved: false
  }

  handleSubmit = data =>
    this.props.onAddLogs(data, this.props.activityId, {
      resetForm: this.props.reset
    })

  render() {
    const {
      reset,
      modalId,
      colorClass,
      handleSubmit,
      submitDisabled,
      submitting,
      storeRemoved
    } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title="Add Logs"
        titleKey="moduleTitle.add_logs"
        colorClass={colorClass}
        onClose={reset}
        onSubmit={handleSubmit(this.handleSubmit)}
        noEscape
      >
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <MaterialModal.Content>
            <div>
              <div className="row">

                <div className="col-xs-12 col-sm-6">
                  <InputDate
                    name='startDate'
                    label="Date"
                    intlKey="label.date"
                    maxToday
                  />
                </div>

                <div className="col-xs-12 col-sm-6">
                  <TimePicker
                    name='duration'
                    label="Duration (mins)"
                    intlKey="label.duration"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <Input
                    name="weeksCount"
                    intlKey="label.weeks_count"
                    label="Repetetions (week)"
                    type="number"
                  />
                </div>

                <div className="col-xs-12">
                  <Textarea
                    name='description'
                    label="Description of your progress"
                    intlKey="label.description_of_progress"
                  />
                </div>
              </div>

              <div className="row">
              </div>

              <div className="row">
                <div className="col-xs-12">
                  <ImagePicker
                    name='fileUrls'
                    storeRemoved={storeRemoved}
                    isFile={false}
                  />
                </div>
              </div>
            </div>
          </MaterialModal.Content>

          <MaterialModal.Footer
            action="Add Logs"
            actionKey="button.add_logs"
            isLoading={submitting}
            colorClass={colorClass}
            disabled={submitDisabled || submitting}
            dataTestId="submitAddLogButtonSelector"
          />
        </form>
      </MaterialModal.Body>
    )
  }
}

export default AddLogs
